var map = {
	"./choose_1_2.png": "j5tk",
	"./choose_2_2.png": "ljks"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "RBZs";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/choose_.*_2\.png$
// module id = RBZs
// module chunks = 0